<template>
  <svg
    width="52"
    height="52"
    viewBox="0 0 52 52"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M10 26C10 17.1634 17.1634 10 26 10C34.8366 10 42 17.1634 42 26C42 34.8366 34.8366 42 26 42C17.1634 42 10 34.8366 10 26ZM26 2C12.7452 2 2 12.7452 2 26C2 39.2548 12.7452 50 26 50C39.2548 50 50 39.2548 50 26C50 12.7452 39.2548 2 26 2Z"
      fill="#55ACEE"
      stroke="white"
      stroke-width="4"
    />
    <path
      d="M34.7333 19.6L23 31.3333L17.6666 26"
      stroke="#55ACEE"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
</template>
